import { TutorialProps } from '@/services/tutorialService/tutorialTypes';
import { useLocalization } from '@/services/localizationService';

export const useBulkUploadTutorial = () => {
  const tutorialId = 'tutorial-bulk';

  const { data } = useLocalization();

  const bulkUploadTutorialSteps: TutorialProps['steps'] = [
    {
      id: 'multiple-selection',
      description: data.result.tutorialMultipleSelectionText,
      index: 1,
      position: 'left',
    },
    {
      id: 'batch-delete',
      description: data.result.tutorialDeleteText,
      index: 2,
      position: 'left',
    },
    {
      id: 'batch-download',
      description: data.result.tutorialDownloadText,
      index: 3,
      position: 'bottom',
    },
  ];

  return {
    bulkUploadTutorialId: tutorialId,
    bulkUploadTutorialSteps,
  };
};
